import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import JsonBlockGenerator from '../components/JsonBlockGenerator';

export default class HhBedRooms extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <JsonBlockGenerator filename={'hh_bedrooms.json'} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
